import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Youtube } from "lucide-react";
import Logo from "./Logo";
import { CONTACT_ADDRESS, CONTACT_EMAIL, CONTACT_PHONE } from "../constants/contact";

const COLS = [
  {
    title: "Kurumsal",
    links: [
      { label: "Hakkımızda", to: "/hakkimizda" },
      { label: "Kariyer", to: "/hakkimizda" },
      { label: "Reklam", to: "/iletisim" },
      { label: "KVKK", to: "/gizlilik-politikasi#kvkk" },
      { label: "İletişim", to: "/iletisim" },
    ],
  },
  {
    title: "Keşfet",
    links: [
      { label: "Programlarımız", to: "/programlar" },
      { label: "Video Programları", to: "/videolar" },
      { label: "Canlı Yayınlar", to: "/canli-yayin" },
      { label: "Arşiv", to: "/videolar" },
    ],
  },
  {
    title: "Yardım",
    links: [
      { label: "Sıkça Sorulan Sorular", to: "/sss" },
      { label: "Kullanım Koşulları", to: "/kullanim-kosullari" },
      { label: "Gizlilik Politikası", to: "/gizlilik-politikasi" },
    ],
  },
];

const SOCIAL = [Facebook, Twitter, Instagram, Youtube];

export default function Footer() {
  const [email, setEmail] = useState("");

  return (
    <footer className="relative mt-24 border-t border-[var(--tv-border)] bg-[#08080f]">
      <div className="tv-container py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
          <div className="col-span-2 lg:col-span-2">
            <Logo size="lg" />
            <p className="text-sm text-[var(--tv-muted)] mt-5 max-w-sm leading-relaxed">
              TV13, haberden spora, kültürden sanata hayatın her alanına dair güvenilir içerikler
              sunan bir yayın platformudur.
            </p>
            <div className="mt-6 space-y-2 text-sm text-[var(--tv-muted)]">
              <p className="flex items-center gap-2"><Phone size={15} className="text-[var(--tv-purple)]" /> {CONTACT_PHONE}</p>
              <p className="flex items-center gap-2"><Mail size={15} className="text-[var(--tv-purple)]" /> {CONTACT_EMAIL}</p>
              <p className="flex items-center gap-2"><MapPin size={15} className="text-[var(--tv-purple)]" /> {CONTACT_ADDRESS}</p>
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-white font-semibold mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l, i) => (
                  <li key={i}>
                    <Link to={l.to} className="text-sm text-[var(--tv-muted)] hover:text-[var(--tv-purple-bright)] transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-[var(--tv-border)] flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-3">
            <span className="text-sm text-[var(--tv-muted)]">Bizi Takip Edin</span>
            <div className="flex gap-2.5">
              {SOCIAL.map((Icon, i) => (
                <button
                  key={i}
                  className="w-9 h-9 rounded-full border border-[var(--tv-border)] flex items-center justify-center text-[var(--tv-muted)] hover:text-white hover:border-[rgba(168,85,247,0.55)] hover:bg-[rgba(139,92,246,0.1)] transition-all"
                >
                  <Icon size={16} />
                </button>
              ))}
            </div>
          </div>
          <p className="text-sm text-[var(--tv-muted)]">© 2026 TV13. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
}
